import { injectionContainer } from '~commonInfra/utils/injectionContainer';
import { ExplorableItemType, SpaceInfoItemType } from '~src/spacesPlatform/models/ContentType';

import { ExplorableItemDefinition, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';


export const {
  get: getMixedContentInOrder,
  set: setMixedContentInOrder
} = injectionContainer< MixedContentItemDefinition[] >('mixedContentInOrder');


export const {
  get: getCollectionSpaceContentInOrder,
  set: setCollectionSpaceContentInOrder
} = injectionContainer< MixedContentItemDefinition[] >('collectionSpaceContentInOrder');


export const {
  get: getPersonalSpaceContentInOrder,
  set: setPersonalSpaceContentInOrder
} = injectionContainer< MixedContentItemDefinition[] >('personalSpaceContentInOrder');


export const {
  get: getFavoriteMixedContentInOrder,
  set: setFavoriteMixedContentInOrder
} = injectionContainer< MixedContentItemDefinition[] >('favoriteMixedContentInOrder');


const {
  get: internalGetExplorableItemDefinitions,
  set: setExplorableItemDefinitions
} = injectionContainer< Record<ExplorableItemType, ExplorableItemDefinition> >('explorableItemDefinitions');

function getExplorableItemDefinition(itemType: ExplorableItemType) {
  return internalGetExplorableItemDefinitions()[itemType];
}

export {setExplorableItemDefinitions, getExplorableItemDefinition};


const {
  get: internalGetContentSpaceDefinitions,
  set: setContentSpaceDefinitions
} = injectionContainer< { [C in SpaceInfoItemType]: SpaceDefinition<C> } >('contentSpaceDefinitions');

function getContentSpaceDefinition(itemType: SpaceInfoItemType) {
  return internalGetContentSpaceDefinitions()[itemType];
}

export {setContentSpaceDefinitions, getContentSpaceDefinition};
